import Vue from 'vue';
export const EventBus = new Vue();


// WEBPACK FOOTER //
// ./ClientApp/app/event-bus.js